import { inject, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store';
import { loadSession } from './store/actions/session.actions';

export function initializeSession(): Promise<void> {
  const store = inject(Store<AppState>);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const document = inject(DOCUMENT);

  if (!isPlatformBrowser(platformId) || !document.defaultView) {
    return Promise.resolve();
  }

  const urlParams = new URLSearchParams(document.defaultView.location.search);
  const participantId = urlParams.get('participantId');

  if (!participantId) {
    router.navigate(['/not-found']);
    return Promise.resolve();
  }

  store.dispatch(loadSession({ participantId }));

  return new Promise<void>((resolve) => {
    const subscription = store
      .select((state) => state.session)
      .subscribe((sessionState) => {
        if (!sessionState.isLoading) {
          if (sessionState.error !== null) {
            router.navigate(['/not-found']);
          }
          subscription.unsubscribe();
          resolve();
        }
      });
  });
}
